<div class="container" *ngIf="currentSession">
    <form (submit)="validate($event)">
        <div class="row">
            <div class="form">
                <h3 class="block_title">
                    {{ 'global.form.required' | translate }} :
                </h3>
                <div class="row">
                    <div class="col-md-4">
                        <label for="training">
                            {{ 'session-form.training' | translate }}
                        </label>
                    </div>
                    <div class="col-md-7">
                        <input
                            auto-complete
                            [(ngModel)]="currentSession.training"
                            [source]="fetchTrainings.bind(this)"
                            [list-formatter]="myListFormatter"
                            [accept-user-input]="false"
                            min-chars="2"
                            display-property-name="title"
                            id="training"
                            class="form-control"
                            name="training"
                            (valueChanged)="onTrainingSelected($event)"
                            (focus)="focusOnTrainingAutocomplete()"
                            required
                            autocomplete="off"
                        />
                    </div>
                    <div class="col-md-1 input-ok">
                        <span class="check" *ngIf="trainingSelected">
                            <i class="fa fa-check" aria-hidden="true"></i>
                        </span>
                        <span class="times" *ngIf="!trainingSelected">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                    </div>
                </div>
                <div
                    class="row"
                    *ngIf="
                        trainingSelected &&
                        currentSession.training.materialReady === false
                    "
                >
                    <div class="col-md-12">
                        <span class="times">
                            <i class="fa fa-warning" aria-hidden="true"></i>
                            {{ 'global.materialNotReadyWarning' | translate }}
                            {{ 'session-form.see' | translate }}
                            <a
                                uiSref="training-detail"
                                [uiParams]="{ id: currentSession.training.id }"
                            >
                                {{ currentSession.training.title }}
                            </a>
                        </span>
                    </div>
                </div>
                <div class="row" *ngIf="customTraining">
                    <div class="col-md-4">
                        <label for="subject">
                            {{ 'session-form.subject' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <input
                            type="text"
                            class="form-control"
                            id="subject"
                            [(ngModel)]="
                                currentSession.trainingSessionExtended.subject
                            "
                            name="subject"
                            required="customTraining"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="date">
                            {{ 'session-form.date' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <input
                            type="date"
                            class="form-control"
                            id="date"
                            required
                            [(ngModel)]="cleanStartDate"
                            name="date"
                            (change)="
                                findUnavailableRoomsForWeek();
                                checkDate();
                                fetchHours()
                            "
                        />
                    </div>
                </div>
                <div class="row" *ngIf="showDateError">
                    <div class="col-md-4"></div>
                    <div class="col-md-8 end-date-error">
                        <i
                            class="fa fa-exclamation-triangle"
                            aria-hidden="true"
                        ></i>
                        La session doit se dérouler uniquement sur des jours
                        ouvrées
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for="duration">
                            {{ 'session-form.duration' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <input
                            type="text"
                            class="form-control"
                            id="duration"
                            required
                            [ngModel]="currentSession.days | commaDot"
                            (ngModelChange)="updateDays($event)"
                            name="duration"
                            autocomplete="false"
                            (change)="testIfRoomIsAvailable()"
                            min-chars="3"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <button
                            class="btn"
                            uiSref="hours-modal"
                            [disabled]="!cleanStartDate || !currentSession.days"
                            [title]="
                                !cleanStartDate || !currentSession.days
                                    ? 'Date et Durée en jours doivent être saisie préalablement'
                                    : ''
                            "
                            (click)="openEditHoursModal(hoursModal)"
                        >
                            {{ 'session-form.modifyHours' | translate }}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label>
                            {{ 'session-form.type' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <label class="center-block radio-input-inline">
                            <input
                                [checked]="currentSession.type == 'PUBLIC'"
                                (change)="updateCurrentSessionType($event)"
                                type="radio"
                                value="PUBLIC"
                                name="radio"
                                required
                            />
                            Inter
                        </label>
                        <label class="center-block radio-input-inline">
                            <input
                                type="radio"
                                value="ONSITE"
                                name="radio"
                                [checked]="currentSession.type == 'ONSITE'"
                                (change)="updateCurrentSessionType($event)"
                                required
                            />
                            Intra
                        </label>
                        <label class="center-block radio-input-inline">
                            <input
                                [checked]="currentSession.type == 'ONDEMAND'"
                                type="radio"
                                value="ONDEMAND"
                                (change)="updateCurrentSessionType($event)"
                                name="radio"
                                required
                            />
                            E-learning/Voucher
                        </label>
                        <label class="center-block radio-input-inline">
                            <input
                                [checked]="currentSession.type == 'OTHER'"
                                type="radio"
                                value="OTHER"
                                name="radio"
                                (change)="updateCurrentSessionType($event)"
                                required
                            />
                            Autre
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label>
                            {{ 'global.language.label' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <select
                            class="form-control"
                            id="language"
                            required
                            [(ngModel)]="currentSession.language"
                            name="language"
                            #name="ngModel"
                            *jhiHasAnyAuthority="'ROLE_ADMIN'"
                        >
                            <option value="fr">
                                {{ 'global.language.fr' | translate }}
                            </option>
                            <option value="en">
                                {{ 'global.language.en' | translate }}
                            </option>
                        </select>
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                            {{ currentSession.language }}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label>
                            {{ 'global.timezone' | translate }}
                        </label>
                    </div>
                    <div class="col-md-8">
                        <select
                            class="form-control"
                            id="timezone"
                            required
                            [(ngModel)]="currentSession.timezone"
                            name="timezone"
                            (change)="updateSynchronizeSignatureValue()"
                            #name="ngModel"
                            *jhiHasAnyAuthority="'ROLE_ADMIN'"
                        >
                            <option
                                *ngFor="let timezone of timezones"
                                [value]="timezone"
                                [selected]="
                                    currentSession
                                        ? timezone === currentSession.timezone
                                        : timezone === 'Europe/Paris'
                                "
                            >
                                {{ timezone }}
                            </option>
                        </select>
                        <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                            {{ currentSession.timezone }}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <label>
                            <input
                                type="checkbox"
                                value="true"
                                name="synchronizeSignature"
                                [(ngModel)]="
                                    currentSession.synchronizeSignature
                                "
                                required
                            />
                            {{
                                'session-form.synchronizeWithSignature'
                                    | translate
                            }}
                        </label>
                    </div>
                </div>
                <div
                    *ngIf="
                        trainingSelected &&
                        cleanStartDate &&
                        currentSession.days > 0
                    "
                >
                    <h3 class="block_title">
                        {{ 'global.form.optional' | translate }} :
                    </h3>
                    <div class="row" *ngIf="customTraining">
                        <div class="col-md-4">
                            <label for="linkedTraining">
                                {{ 'session-form.linkedTraining' | translate }}
                            </label>
                        </div>
                        <div class="col-md-7">
                            <input
                                auto-complete
                                [(ngModel)]="
                                    currentSession.trainingSessionExtended
                                        .linkedTraining
                                "
                                [source]="fetchTrainings.bind(this)"
                                [list-formatter]="myListFormatter"
                                [accept-user-input]="false"
                                min-chars="3"
                                display-property-name="title"
                                id="linkedTraining"
                                class="form-control"
                                name="linkedTraining"
                                (valueChanged)="
                                    onLinkedTrainingSelected($event)
                                "
                                (focus)="focusOnLinkedTrainingAutocomplete()"
                                autocomplete="off"
                            />
                        </div>
                        <div class="col-md-1 input-ok">
                            <span class="check" *ngIf="linkedTrainingSelected">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </span>
                            <span class="times" *ngIf="!linkedTrainingSelected">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label for="googleDriveLink">
                                {{ 'session-form.googleDriveLink' | translate }}
                            </label>
                        </div>
                        <div class="col-md-8">
                            <input
                                type="text"
                                class="form-control"
                                id="googleDriveLink"
                                [(ngModel)]="
                                    currentSession.trainingSessionExtended
                                        .googleDriveLink
                                "
                                name="googleDriveLink"
                            />
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="trainer">
                                {{ 'session-form.trainer' | translate }}
                            </label>
                        </div>
                        <div class="col-md-7">
                            <input
                                auto-complete
                                [(ngModel)]="currentSession.trainer"
                                [source]="fetchTrainers.bind(this)"
                                [list-formatter]="myTrainerListFormatter"
                                [accept-user-input]="false"
                                min-chars="3"
                                [max-num-list]="14"
                                id="trainer"
                                class="form-control"
                                name="trainer"
                                display-property-name="fullName"
                                (focus)="focusOnTrainerAutocomplete()"
                                autocomplete="off"
                            />
                        </div>
                        <div class="col-md-1 input-ok">
                            <span class="check" *ngIf="currentSession.trainer">
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </span>
                            <span class="times" *ngIf="!currentSession.trainer">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="col-md-4">
                            <label for="additionalTrainers">
                                {{
                                    'session-form.additionalTrainers'
                                        | translate
                                }}
                            </label>
                        </div>
                        <div class="col-md-7">
                            <input
                                auto-complete
                                [(ngModel)]="additionalTrainerInInput"
                                [source]="fetchTrainers.bind(this)"
                                [list-formatter]="myTrainerListFormatter"
                                [accept-user-input]="false"
                                min-chars="3"
                                [max-num-list]="14"
                                id="additionalTrainers"
                                class="form-control"
                                name="additionalTrainers"
                                display-property-name="fullName"
                                (valueChanged)="
                                    focusOnAdditionalTrainersAutocomplete(
                                        additionalTrainerInInput
                                    )
                                "
                                autocomplete="off"
                            />
                        </div>
                        <div class="col-md-1 input-ok">
                            <span
                                class="check"
                                *ngIf="additionalTrainerInInput"
                            >
                                <i class="fa fa-check" aria-hidden="true"></i>
                            </span>
                            <span
                                class="times"
                                *ngIf="!additionalTrainerInInput"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div
                            *ngFor="
                                let additionalTrainer of currentSession.additionalTrainers;
                                index as i
                            "
                            class="badge badge-light additional-trainer-badge"
                        >
                            <span>
                                {{ additionalTrainer.fullName }}
                            </span>
                            <button
                                type="button"
                                class="btn btn-link btn-sm"
                                aria-label="Close"
                                (click)="removeAdditionalTrainer(i)"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="price">
                                {{ 'session-form.price' | translate }}
                            </label>
                        </div>
                        <div class="col-md-3">
                            <input
                                class="form-control"
                                id="price"
                                required
                                [(ngModel)]="priceNoCents"
                                name="price"
                                type="number"
                                min="0"
                            />
                        </div>
                        <div class="col-md-3">
                            <select
                                [(ngModel)]="
                                    currentSession.billing.priceCurrency
                                "
                                name="priceCurrency"
                                id="priceCurrency"
                                class="form-control"
                            >
                                <option value="EURO">€</option>
                                <option value="DOLLAR">$</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <div>
                                <input
                                    type="radio"
                                    value="REAL"
                                    name="radio"
                                    [(ngModel)]="
                                        currentSession.billing.expensesType
                                    "
                                />
                                {{ 'session-form.realExpenses' | translate }}
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    value="FIXED"
                                    name="radio"
                                    [(ngModel)]="
                                        currentSession.billing.expensesType
                                    "
                                />
                                {{ 'session-form.fixedFee' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="educFees">
                                {{ 'session-form.educFees' | translate }}
                            </label>
                        </div>
                        <div class="col-md-6">
                            <input
                                type="number"
                                min="0"
                                class="form-control"
                                id="educFees"
                                [(ngModel)]="currentSession.fees.educFees"
                                name="educFees"
                            />
                        </div>
                        <div class="col-md-2">
                            <select
                                [(ngModel)]="
                                    currentSession.fees.educFeesCurrency
                                "
                                name="educFeesCurrency"
                                id="educFeesCurrency"
                                class="form-control"
                            >
                                <option value="EURO">€</option>
                                <option value="DOLLAR">$</option>
                            </select>
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="amountsPaid">
                                {{ 'session-form.amountsPaid' | translate }}
                            </label>
                        </div>
                        <div class="col-md-6">
                            <input
                                type="number"
                                min="0"
                                class="form-control"
                                id="amountsPaid"
                                [(ngModel)]="currentSession.fees.amountsPaid"
                                name="amountsPaid"
                            />
                        </div>
                        <div class="col-md-2">
                            <select
                                [(ngModel)]="
                                    currentSession.fees.amountsPaidCurrency
                                "
                                name="amountsPaidCurrency"
                                id="amountsPaidCurrency"
                                class="form-control"
                            >
                                <option value="EURO">€</option>
                                <option value="DOLLAR">$</option>
                            </select>
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="lunches">
                                {{ 'session-form.lunches' | translate }}
                            </label>
                        </div>
                        <div class="col-md-6">
                            <input
                                type="number"
                                min="0"
                                class="form-control"
                                id="lunches"
                                [(ngModel)]="currentSession.fees.lunches"
                                name="lunches"
                            />
                        </div>
                        <div class="col-md-2">
                            <select
                                [(ngModel)]="
                                    currentSession.fees.lunchesCurrency
                                "
                                name="lunchesCurrency"
                                id="lunchesCurrency"
                                class="form-control"
                            >
                                <option value="EURO">€</option>
                                <option value="DOLLAR">$</option>
                            </select>
                        </div>
                    </div>
                    <div class="row" *ngIf="isAdmin">
                        <div class="col-md-4">
                            <label for="roomRental">
                                {{ 'session-form.roomRental' | translate }}
                            </label>
                        </div>
                        <div class="col-md-6">
                            <input
                                type="number"
                                min="0"
                                class="form-control"
                                id="roomRental"
                                [(ngModel)]="currentSession.fees.roomRental"
                                name="roomRental"
                            />
                        </div>
                        <div class="col-md-2">
                            <select
                                [(ngModel)]="
                                    currentSession.fees.roomRentalCurrency
                                "
                                name="roomRentalCurrency"
                                id="roomRentalCurrency"
                                class="form-control"
                            >
                                <option value="EURO">€</option>
                                <option value="DOLLAR">$</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <label for="comments">
                                {{ 'session-form.description' | translate }}
                            </label>
                        </div>
                        <div class="col-md-8">
                            <textarea
                                class="form-control"
                                id="comments"
                                [(ngModel)]="currentSession.billing.comments"
                                name="comments"
                            >
                            </textarea>
                        </div>
                    </div>
                    <h3 class="block_title" *ngIf="isAdmin">
                        {{ 'session-form.trainingLocation' | translate }}
                        ({{ 'global.form.optional' | translate }}) :
                    </h3>
                    <div *ngIf="isAdmin">
                        <div class="row">
                            <div class="col-md-4">
                                <label>
                                    {{
                                        'session-form.locationType' | translate
                                    }}:
                                </label>
                            </div>
                            <div class="col-md-6">
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="COMPANY"
                                        name="radioLoc"
                                        [(ngModel)]="
                                            currentSession.locationType
                                        "
                                        (ngModelChange)="
                                            onLocationTypeChanged()
                                        "
                                    />
                                    {{ 'session-form.company' | translate }}
                                </label>
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="ZENIKA"
                                        name="radioLoc"
                                        [(ngModel)]="
                                            currentSession.locationType
                                        "
                                        (ngModelChange)="
                                            onLocationTypeChanged()
                                        "
                                    />
                                    {{ 'session-form.ourRooms' | translate }}
                                </label>
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="PARTNER"
                                        name="radioLoc"
                                        [(ngModel)]="
                                            currentSession.locationType
                                        "
                                        (ngModelChange)="
                                            onLocationTypeChanged()
                                        "
                                    />
                                    {{
                                        'session-form.partnerLocation'
                                            | translate
                                    }}
                                </label>
                                <label class="center-block radio-input-inline">
                                    <input
                                        type="radio"
                                        value="REMOTE"
                                        name="radioLoc"
                                        [(ngModel)]="
                                            currentSession.locationType
                                        "
                                        (ngModelChange)="
                                            onLocationTypeChanged()
                                        "
                                    />
                                    {{
                                        'session-form.remoteLocation'
                                            | translate
                                    }}
                                </label>
                            </div>
                        </div>
                        <!-- Company location -->
                        <div *ngIf="currentSession.locationType === 'COMPANY'">
                            <div class="row">
                                <div class="col-md-4">
                                    <label for="company">
                                        {{ 'session-form.company' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-5">
                                    <input
                                        auto-complete
                                        [(ngModel)]="currentSession.company"
                                        [source]="fetchCompanies.bind(this)"
                                        [list-formatter]="
                                            myCompanyListFormatter
                                        "
                                        [accept-user-input]="false"
                                        min-chars="3"
                                        id="company"
                                        class="form-control"
                                        name="company"
                                        display-property-name="name"
                                        (focus)="focusOnCompanyAutocomplete()"
                                        autocomplete="off"
                                        (valueChanged)="
                                            onCompanyChanged($event)
                                        "
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- Zenika location -->
                        <div *ngIf="currentSession.locationType === 'ZENIKA'">
                            <div class="row">
                                <div class="col-md-4">
                                    <label for="zenikaLocations">
                                        {{ 'session-form.agency' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-5">
                                    <input
                                        auto-complete
                                        [(ngModel)]="currentSession.location"
                                        [source]="zenikaLocations"
                                        [list-formatter]="
                                            myLocationListFormatter
                                        "
                                        [accept-user-input]="false"
                                        min-chars="0"
                                        id="zenikaLocations"
                                        class="form-control"
                                        name="zenikaLocations"
                                        display-property-name="name"
                                        (valueChanged)="zenikaLocationChanged()"
                                        (focus)="
                                            focusOnZenikaLocationAutocomplete()
                                        "
                                        autocomplete="off"
                                    />
                                </div>
                                <div class="col-md-1 input-ok">
                                    <span
                                        class="check"
                                        *ngIf="zenikaLocationSelected"
                                    >
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                    <span
                                        class="times"
                                        *ngIf="!zenikaLocationSelected"
                                    >
                                        <i
                                            class="fa fa-times"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                            <div class="row" *ngIf="zenikaLocationSelected">
                                <div class="col-md-4">
                                    <label for="rooms">
                                        {{ 'session-form.room' | translate }}
                                    </label>
                                </div>
                                <div class="col-md-5">
                                    <input
                                        auto-complete
                                        [(ngModel)]="currentSession.room"
                                        [source]="currentSession.location.rooms"
                                        [list-formatter]="
                                            myLocationListFormatter
                                        "
                                        [accept-user-input]="false"
                                        min-chars="0"
                                        id="rooms"
                                        class="form-control"
                                        name="rooms"
                                        display-property-name="name"
                                        (valueChanged)="roomSelected = true"
                                        (focus)="focusOnRoomAutocomplete()"
                                        autocomplete="off"
                                    />
                                </div>
                                <div class="col-md-1 input-ok">
                                    <span class="check" *ngIf="roomSelected">
                                        <i
                                            class="fa fa-check"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                    <span class="times" *ngIf="!roomSelected">
                                        <i
                                            class="fa fa-times"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Partner location -->
                    <div *ngIf="currentSession.locationType === 'PARTNER'">
                        <div class="row">
                            <div class="col-md-4">
                                <label for="partnerLocations">
                                    {{ 'session-form.partner' | translate }}
                                </label>
                            </div>
                            <div class="col-md-5">
                                <input
                                    auto-complete
                                    [(ngModel)]="currentSession.location"
                                    [source]="
                                        searchPartnersLocations.bind(this)
                                    "
                                    [list-formatter]="myLocationListFormatter"
                                    [accept-user-input]="false"
                                    min-chars="3"
                                    [max-num-list]="14"
                                    id="partnerLocations"
                                    class="form-control"
                                    name="partnerLocations"
                                    display-property-name="name"
                                    (valueChanged)="partnerLocationChanged()"
                                    (focus)="
                                        focusOnPartnerLocationAutocomplete()
                                    "
                                    autocomplete="off"
                                />
                            </div>
                            <div class="col-md-1 input-ok">
                                <span
                                    class="check"
                                    *ngIf="partnerLocationSelected"
                                >
                                    <i
                                        class="fa fa-check"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                                <span
                                    class="times"
                                    *ngIf="!partnerLocationSelected"
                                >
                                    <i
                                        class="fa fa-times"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="currentSession.locationType !== 'REMOTE'"
                        class="row"
                    >
                        <div class="col-md-4">
                            <label for="address">
                                {{ 'session-form.address' | translate }}
                            </label>
                        </div>
                        <div class="col-md-8">
                            <textarea
                                type="text"
                                class="form-control"
                                id="address"
                                [(ngModel)]="
                                    currentSession.trainingSessionExtended
                                        .address
                                "
                                name="address"
                            ></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div
                            style="
                                margin: 30px 0px 30px 0px;
                                display: flex;
                                justify-content: space-between;
                            "
                        >
                            <button
                                class="btn btn-primary"
                                [disabled]="submitDisabled"
                                type="submit"
                                name="submit"
                            >
                                {{ 'session-form.save' | translate }}
                            </button>
                            <a
                                class="btn btn-default"
                                (click)="showModal(deleteModal)"
                            >
                                {{ 'session-form.delete' | translate }}
                            </a>
                        </div>
                        <div *ngIf="success" class="alert alert-success">
                            <strong>Réussi !</strong>
                        </div>
                        <div *ngIf="invalidForm" class="alert alert-danger">
                            <strong
                                >Formulaire invalide ! Les frais ne sont pas
                                tous remplis.
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6" *ngIf="locationSelected">
                <table class="table table-bordered availabilities">
                    <caption style="caption-side: bottom">
                        {{
                            'session-form.availabilityRooms' | translate
                        }}
                        {{
                            unavailableRooms.weekStartDate | date
                        }}
                    </caption>
                    <tr>
                        <th colspan="6">
                            {{ 'session-form.weekFrom' | translate }}
                            {{ unavailableRooms.weekStartDate | date }}
                            {{ 'to' }}
                            {{ unavailableRooms.weekEndDate | date }}
                        </th>
                    </tr>
                    <tr class="left">
                        <th>{{ 'session-form.room' | translate }}</th>
                        <th class="days">
                            {{ 'session-form.mon' | translate }}
                            {{ unavailableRooms.weekStartDateW[0] }}
                        </th>
                        <th class="days">
                            {{ 'tsession-form.ue' | translate }}
                            {{ unavailableRooms.weekStartDateW[1] }}
                        </th>
                        <th class="days">
                            {{ 'session-form.wed' | translate }}
                            {{ unavailableRooms.weekStartDateW[2] }}
                        </th>
                        <th class="days">
                            {{ 'session-form.thu' | translate }}
                            {{ unavailableRooms.weekStartDateW[3] }}
                        </th>
                        <th class="days">
                            {{ 'fsession-form.ry' | translate }}
                            {{ unavailableRooms.weekStartDateW[4] }}
                        </th>
                    </tr>
                    <tr *ngFor="let room of availabilityTable">
                        <td class="left">
                            {{ room.name }}
                        </td>
                        <td [class]="room.monday ? 'red' : 'green'">
                            <i *ngIf="room.monday" class="fa fa-times"></i>
                            <i *ngIf="!room.monday" class="fa fa-check"></i>
                        </td>
                        <td [class]="room.tuesday ? 'red' : 'green'">
                            <i *ngIf="room.tuesday" class="fa fa-times"></i>
                            <i *ngIf="!room.tuesday" class="fa fa-check"></i>
                        </td>
                        <td [class]="room.wednesday ? 'red' : 'green'">
                            <i *ngIf="room.wednesday" class="fa fa-times"></i>
                            <i *ngIf="!room.wednesday" class="fa fa-check"></i>
                        </td>
                        <td [class]="room.thursday ? 'red' : 'green'">
                            <i *ngIf="room.thursday" class="fa fa-times"></i>
                            <i *ngIf="!room.thursday" class="fa fa-check"></i>
                        </td>
                        <td [class]="room.friday ? 'red' : 'green'">
                            <i *ngIf="room.friday" class="fa fa-times"></i>
                            <i *ngIf="!room.friday" class="fa fa-check"></i>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </form>
</div>

<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">
            Etes-vous sur de vouloir supprimer cette session ?
        </h4>
        <div class="checkbox" *ngIf="currentSession.trainer">
            <label for="notifyTrainer">
                <input
                    name="notifyTrainer"
                    type="checkbox"
                    [(ngModel)]="notifyTrainerOnDeletion"
                />
                {{ 'session-form.notifyTrainer' | translate }}
            </label>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="closeModal()">
            Annuler
        </button>
        <button type="button" class="btn btn-primary" (click)="removeSession()">
            Supprimer
        </button>
    </div>
</ng-template>

<ng-template #hoursModal>
    <div id="edit-hours-modal" class="modal-header">
        <h4 class="modal-title">
            ⏲ {{ 'session-form.hours.title' | translate }}
        </h4>
        <div id="hours-list">
            <div
                class="hours-row"
                *ngFor="let hours of editedHoursList; let i = index"
            >
                <label
                    >{{ 'session-form.hours.date' | translate }}
                    <input
                        type="date"
                        required
                        (change)="checkHoursFields()"
                        [(ngModel)]="hours.date"
                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                    />
                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{
                        hours.date
                    }}</span>
                </label>
                <label>
                    {{ 'session-form.hours.startAt' | translate }}
                    <input
                        type="time"
                        required
                        (change)="checkHoursFields()"
                        [(ngModel)]="hours.startTime"
                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                    />
                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{
                        hours.startTime
                    }}</span>
                </label>
                <label>
                    {{ 'session-form.hours.endAt' | translate }}
                    <input
                        type="time"
                        required
                        (change)="checkHoursFields()"
                        [(ngModel)]="hours.endTime"
                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                    />
                    <span *jhiHasAnyAuthority="'!ROLE_ADMIN'">{{
                        hours.endTime
                    }}</span>
                </label>
                <div class="remove-icon" (click)="removeHours(i)">
                    <i
                        class="fa fa-trash-o fa-2x"
                        aria-hidden="true"
                        *jhiHasAnyAuthority="'ROLE_ADMIN'"
                    ></i>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="editedHoursList.length === 0">
            <div class="error-message col-md-12">
                {{ 'session-form.hours.list-is-empty' | translate }}
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button
                    class="btn btn-default"
                    (click)="addHour()"
                    type="button"
                    *jhiHasAnyAuthority="'ROLE_ADMIN'"
                >
                    {{ 'session-form.hours.add' | translate }}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <button
                    class="btn btn-default"
                    (click)="resetToDefaultHours()"
                    type="button"
                    *jhiHasAnyAuthority="'ROLE_ADMIN'"
                >
                    {{ 'session-form.hours.resetToDefaultHours' | translate }}
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <button
                    class="btn btn-primary"
                    [attr.disabled]="isHoursValid ? null : true"
                    (click)="applyHoursModification()"
                    type="button"
                    *jhiHasAnyAuthority="'ROLE_ADMIN'"
                >
                    OK
                </button>
            </div>
            <div class="col-md-6 cancel">
                <button
                    class="btn btn-default"
                    (click)="cancelHoursModifications()"
                    type="button"
                    *jhiHasAnyAuthority="'ROLE_ADMIN'"
                >
                    {{ 'global.cancel' | translate }}
                </button>
            </div>
        </div>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/form/form.component.html